import React, { useEffect, useState } from 'react'
import { Link, useLocation, useMatches } from 'react-router-dom'
import { useAppSelector } from '../utils/agent.store'
import { SvgVerticalSplitter } from '@ui-kit'
interface CrumbHandleType {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  match: any
}
const CrumbHandle = ({ match }: CrumbHandleType) => {
  const { handle } = match
  const tenantId = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )
  const [redirectTo, setRedirectTo] = useState('')
  const { pathname } = useLocation()
  useEffect(() => {
    if (handle?.redirectTo) {
      const redirectToPath = handle?.redirectTo?.replace(':tenantId', tenantId)
      if (pathname === redirectToPath) {
        setRedirectTo(redirectToPath)
      }
    }
  }, [pathname])
  return (
    <Link className={`text-xs`} to={redirectTo}>
      {handle?.crumb?.()}
    </Link>
  )
}

const BreadCrumb: React.FC = () => {
  const matches = useMatches()
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const matchesWithCrumb = matches.filter((match: any) => {
    return match.handle?.crumb
  })
  const tenantId = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )
  return (
    <>
      {matchesWithCrumb?.length ? (
        <div>
          <SvgVerticalSplitter />
        </div>
      ) : null}
      <div className="bg-accent-50 py-2 px-3 rounded text-accent-900 flex items-center ml-3 gap-1 portal-window">
        {/* eslint-disable  @typescript-eslint/no-explicit-any */}
        {matchesWithCrumb.map((match: any, index: number) => {
          const { handle, pathname } = match
          const redirectTo = handle?.redirectTo?.replace(':tenantId', tenantId)
          return (
            <React.Fragment key={pathname}>
              {redirectTo ? (
                <CrumbHandle match={match} />
              ) : (
                <Link
                  className={`text-xs capitalize ${
                    index >= matchesWithCrumb.length - 1
                      ? 'text-primary-500'
                      : ''
                  }`}
                  to={pathname}
                >
                  {handle?.crumb?.()}
                </Link>
              )}
              {index < matchesWithCrumb.length - 1 ? (
                <span className="text-xs "> / </span>
              ) : (
                <></>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </>
  )
}

export default BreadCrumb
